import { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'

import Box from '@mui/material/Box'
import axios from 'axios'

export default function Markdown({ path }) {
  const [content, setContent] = useState(null)

  useEffect(() => {
    axios.get(path).then(res => setContent(res.data))
  }, [path])

  return (
    <Box sx={{ py: 3, px: 4 }}>
      <ReactMarkdown children={content} />
    </Box>
  )
}
